import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "thumbs-up-click",
  "use": "thumbs-up-click-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"thumbs-up-click\"><path fill=\"#37F\" fill-rule=\"nonzero\" d=\"M9.894 6.204c.287-1.282.487-2.21.602-2.783.287-1.447-.46-2.79-1.938-2.79-1.334 0-2.004.663-2.399 1.988l-.01.039c-.237 1.072-.6 1.902-1.08 2.497-.505.628-1.261 1-2.067 1.018l-.378.008A1.666 1.666 0 0 0 1 7.853v5.49c0 1.118.9 2.025 2.01 2.025h7.124c1.464 0 2.77-.925 3.266-2.312l1.48-4.138a2.031 2.031 0 0 0-1.209-2.594c-.218-.08-.45-.12-.682-.12H9.894Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol